import React, {useEffect, useRef} from 'react';
import Icons from '../../../assets/svgs/icons';
import {motion} from 'framer-motion';
import ReactDOM from 'react-dom';

const container = {
  hidden: {
    opacity: 0,
    transition: {
      when: 'afterChildren',
    },
    transitionEnd: {
      display: 'none',
    },
  },

  visible: {
    opacity: 1,
    display: 'block',
    transition: {
      when: 'beforeChildren',
    },
  },
};

const content = {
  hidden: {y: '110%'},
  visible: {y: '0%'},
};

const BottomSheet = ({visible, onRequestClose, title, children}) => {
  const overflow = useRef();

  useEffect(() => {
    overflow.current = document.createElement('div');
    document.body.appendChild(overflow.current);

    return () => {
      ReactDOM.unmountComponentAtNode(overflow.current);
      document.body.removeChild(overflow.current);
    };
  }, []);

  const child = (
    <motion.div
      initial="hidden"
      variants={container}
      onClick={onRequestClose}
      className="c_bottom_sheet"
      animate={visible ? 'visible' : 'hidden'}>
      <motion.div className="p-2" variants={content} onClick={(e) => e.stopPropagation()}>
        <div className="user-select-none d-flex justify-content-center align-items-center px-2 py-4">
          <h2 className="title">{title}</h2>
          <span className="icon" onClick={onRequestClose}>
            <Icons name={'chevron_down'} size={'1rem'} color={'#757575'} />
          </span>
        </div>
        {children}
      </motion.div>
    </motion.div>
  );

  const render = () => {
    ReactDOM.render(child, overflow.current);
    return;
  };

  useEffect(render);
  return null;
};

export default React.memo(BottomSheet);
